import {SummaryModel} from '../../../common/entity/summary.model';
import {PermissionsModel} from '../../../common/entity/permissions.model';
import {FormSummaryModel} from '../../../form/form/api/entity/formSummary.model';

export class ExamFormSummaryModel implements SummaryModel {
    permissions: PermissionsModel;
    form: FormSummaryModel;
    id: number;
}


